import { BusinessContactInfo } from 'rwl-shared/dist/models/Account';

export const normalizeLinks = (contactInfo: BusinessContactInfo) => {
    // If there is a Contact Us Link then change nothing
    if (contactInfo?.businessContactUsLink) {
        return {
            contactUs: contactInfo?.businessContactUsLink,
            email: contactInfo?.businessEmail,
            phoneNumber: contactInfo?.businessPhone,
        };
    }

    // Otherwise if there is a phone number use it for link
    if (contactInfo?.businessPhone) {
        return {
            contactUs: `tel:${contactInfo?.businessPhone}`,
            email: contactInfo?.businessEmail,
            // exclude phone since it's being used for primary button
        };
    }

    // Otherwise use the email
    if (contactInfo?.businessEmail) {
        return {
            contactUs: `mailto:${contactInfo?.businessEmail}`,
            phoneNumber: contactInfo?.businessPhone,
            // exclude email since it's being used for primary button
        };
    }

    // fallback to returning nothing
    return {};
};
